import { useRef } from "react";

type ImageZoomWrapperProps = {
  src: string;
  alt: string;
  className: string;
};

const ImageZoomWrapper: React.FC<ImageZoomWrapperProps> = ({
  src,
  alt,
  className,
}) => {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const imgRef = useRef<HTMLImageElement>(null);

  const handleMouseMove = (
    e: React.MouseEvent<HTMLDivElement>
  ) => {
    if (!wrapperRef.current || !imgRef.current) return;
    const { left, top } =
      wrapperRef.current.getBoundingClientRect();
    const x = e.pageX - left;
    const y = e.pageY - top;
    imgRef.current.style.transform = "scale(2)";
    imgRef.current.style.transformOrigin = `${x}px ${y}px`;
  };

  const handleMouseLeave = () => {
    if (imgRef.current) {
      imgRef.current.style.transform = "scale(1)";
    }
  };

  return (
    <div
      ref={wrapperRef}
      className={`${className} mx-auto overflow-hidden`}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
    >
      <img
        ref={imgRef}
        src={src}
        alt={alt}
        className={
          "cursor-zoom-in object-cover transition-transform duration-200 ease-in-out " +
          className
        }
      />
    </div>
  );
};

export default ImageZoomWrapper;
